import { lazy } from 'react'
import { type RouteObject } from 'react-router-dom'

const DaftarClaimPage = lazy(() => import('./pages/daftar-claim'))
const DetailClaimPage = lazy(() => import('./pages/detail-claim'))
const ClaimOperatorPage = lazy(() => import('./pages/claim-operator'))

/** Cluster C11 Customer Claim FG — CLM-01 (daftar), CLM-02 (daftar + detail `:id`), CLM-03 (operator mobile). */
const customerClaimRoutes: RouteObject[] = [
  {
    path: 'customer-claim',
    children: [
      { path: 'daftar-claim', element: <DaftarClaimPage /> },
      {
        path: 'detail-claim',
        children: [
          { index: true, element: <DetailClaimPage /> },
          { path: ':id', element: <DetailClaimPage /> }
        ]
      },
      { path: 'claim-operator', element: <ClaimOperatorPage /> }
    ]
  }
]

export default customerClaimRoutes
